import { render, staticRenderFns } from "./Flag.vue?vue&type=template&id=3c5ed1ae&scoped=true&"
import script from "./Flag.vue?vue&type=script&lang=ts&"
export * from "./Flag.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c5ed1ae",
  null
  
)

export default component.exports